import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { LINKS, INFO } from "@/lib/constants";

const TikTokLogo = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="#C9A84C">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005.1 20.14a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1.14-.14z" />
  </svg>
);

export default function TikTokSection() {
  return (
    <section className="py-28 lg:py-36" style={{ background: "#080808" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="pre-headline mb-6">
          TikTok
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl mb-16"
          data-testid="tiktok-headline"
        >
          Schau uns bei der <span className="gold-text">Arbeit</span> zu.
        </motion.h2>

        <div className="grid sm:grid-cols-3 gap-6">
          {[0, 1, 2].map((i) => (
            <motion.a
              key={i}
              href={LINKS.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="service-card aspect-[9/14] flex flex-col items-center justify-center gap-5 group"
              data-testid={`tiktok-card-${i}`}
            >
              <TikTokLogo />
              <div className="w-14 h-14 rounded-full flex items-center justify-center border transition-colors duration-300 group-hover:bg-[rgba(201,168,76,0.1)]" style={{ borderColor: "rgba(201,168,76,0.4)" }}>
                <Play size={20} fill="#C9A84C" stroke="#C9A84C" className="ml-1" />
              </div>
              <span className="text-sm" style={{ color: "#999999" }}>{INFO.tiktokHandle}</span>
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mt-14 text-center"
        >
          <a href={LINKS.tiktok} target="_blank" rel="noopener noreferrer" className="btn-gold" data-testid="tiktok-more-cta">
            Mehr auf TikTok
          </a>
        </motion.div>
      </div>
    </section>
  );
}
